/**
 * AutoCount - Receive Shipment Page
 */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";
import { useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

const pendingShipments = ["SHP-2026-0043 — RockAuto"];

const shipmentItems = [
  { partNumber: "ALT-GM-160A", name: "Alternator 160A - GM Full-Size Trucks 2014-2023", expected: 6, received: 0 },
  { partNumber: "RAD-TY-RAV4-19", name: "Radiator - Toyota RAV4 2019-2024", expected: 4, received: 0 },
];

const totalExpected = shipmentItems.reduce((sum, i) => sum + i.expected, 0);
const totalReceived = shipmentItems.reduce((sum, i) => sum + i.received, 0);

function ShipmentsReceive(): JSX.Element {
  const navigate = useNavigate();

  const columns = [
    { Header: "Part Number", accessor: "partNumber", width: "20%" },
    { Header: "Name", accessor: "name", width: "35%" },
    { Header: "Expected", accessor: "expected", width: "15%" },
    { Header: "Received", accessor: "received", width: "15%" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Receive Shipment
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                <Grid container spacing={3} mb={3}>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      options={pendingShipments}
                      defaultValue={pendingShipments[0]}
                      renderInput={(params) => <MDInput {...params} label="Select Shipment" />}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput label="Scan Part Number" fullWidth />
                  </Grid>
                </Grid>

                <DataTable
                  table={{ columns, rows: shipmentItems }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                />

                <MDBox mt={3} display="flex" justifyContent="flex-end" gap={2}>
                  <MDButton variant="outlined" color="secondary" onClick={() => navigate("/shipments")}>
                    Save Progress
                  </MDButton>
                  <MDButton variant="gradient" color="success" onClick={() => navigate("/shipments")}>
                    Complete Receiving
                  </MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>

          <Grid item xs={12} lg={4}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h6" mb={2}>Receiving Summary</MDTypography>
                <MDBox mb={2}>
                  <MDTypography variant="caption" color="text">Total Items</MDTypography>
                  <MDTypography variant="h4">{totalExpected}</MDTypography>
                </MDBox>
                <MDBox mb={2}>
                  <MDTypography variant="caption" color="text">Received</MDTypography>
                  <MDTypography variant="h4" color="success">{totalReceived}</MDTypography>
                </MDBox>
                <MDBox>
                  <MDTypography variant="caption" color="text">Remaining</MDTypography>
                  <MDTypography variant="h4" color="warning">{totalExpected - totalReceived}</MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ShipmentsReceive;
